import {getAuthHeader} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';
import {
  viewBoxPreviewByBoxNumberHandlerFunction,
  BoxPreviewByBoxNumberView,
} from '../../../projection/boxPreview/viewBoxPreviewByBoxNumber';

/**
 * These are the default headers introduced by '@lookiero/data-sources'
 * but we won't couple this module to the library.
 */
const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const boxPreviewByBoxNumberView: BoxPreviewByBoxNumberView = async ({boxNumber}) => {
  const authHeaders = await getAuthHeader();

  const payload = {
    box_number: boxNumber,
  };

  const response = await fetch(proxy('/labs/api/view-box-preview-by-box-number'), {
    method: 'POST',
    headers: {...defaultHeaders, ...authHeaders},
    body: JSON.stringify(payload),
  });

  return !response.ok || response.status === 404 ? null : (await response.json()).result;
};

export const viewBoxPreviewByBoxNumberHandler = viewBoxPreviewByBoxNumberHandlerFunction(boxPreviewByBoxNumberView);
